<template>
  <div>
    <div v-if="['vr','whyc'].indexOf($route.params._field)>-1">
      <bs-detail
        :filter="filter"
        :meta="meta"
        @on-data-after="handleTitle"
        v-if="['vr'].indexOf($route.params._field)>-1"
        ref="refId"
        content-class
      >
        <template slot="data" slot-scope="slot">
          <portal-arti-detail-vr :result="slot"></portal-arti-detail-vr>
        </template>
        <template slot="empty">
          <div class="list-none">
            <ul></ul>
          </div>
        </template>
      </bs-detail>
      <bs-detail
        :filter="filter"
        :meta="meta"
        @on-data-after="handleTitle"
        v-if="['whyc'].indexOf($route.params._field)>-1"
        ref="refId"
        content-class
      >
        <template slot="data" slot-scope="slot">
          <portal-arti-detail-whyc :result="slot"></portal-arti-detail-whyc>
        </template>
        <template slot="empty">
          <div class="list-none">
            <ul></ul>
          </div>
        </template>
      </bs-detail>
    </div>
    <div v-else>
      <div :class="`m-portal m-portal-${routeType}-main`">
        <portal-nav-top></portal-nav-top>
        <div id="ljh-culture">
          <div class="container-fluid" style="width:1100px;">
            <el-row :gutter="20">
              <el-col :span="6" class="left-menu-wrap">
                <portal-dest-nav v-if="['yjgl_detail'].indexOf($route.params._field)>-1"></portal-dest-nav>
                <portal-cult-nav v-else></portal-cult-nav>
              </el-col>
              <el-col :span="18" class="content-page-wrap">
                <div class="content-page">
                  <div class="navigation">
                    <span>首页</span>
                    <span>&nbsp;>&nbsp;</span>
                    <span
                      v-if="['3d_detail','720_detail','vr_detail','yjgl_detail'].indexOf($route.params._field)>-1"
                    >文化旅游</span>
                    <span v-else>文化概述</span>
                    <span>&nbsp;>&nbsp;</span>
                    <span
                      style="font-weight:bold;cursor: pointer;"
                      @click="handleArtiPage('article',field[$route.params._field])"
                    >{{title[$route.params._field]}}</span>
                  </div>
                  <div class="article">
                    <bs-detail
                      :filter="filter"
                      :meta="meta"
                      @on-data-after="handleTitle"
                      ref="refId"
                      content-class
                    >
                      <template slot="data" slot-scope="slot">
                        <div
                          v-if="['kw_detail','zzsl_detail','whyc_page','whjt_detail','yjgl_detail','zzcp_detail','zzgs_detail'].indexOf($route.params._field)>-1"
                        >
                          <portal-arti-detail-kw
                            v-if="['kw_detail'].indexOf($route.params._field)>-1"
                            style="line-height:21px;letter-spacing:2px;"
                            :result="slot"
                          ></portal-arti-detail-kw>
                          <portal-arti-detail-dest
                            v-if="['yjgl_detail'].indexOf($route.params._field)>-1"
                            style="line-height:21px;letter-spacing:2px;"
                            :result="slot"
                          ></portal-arti-detail-dest>
                          <portal-arti-detail-whycpage
                            v-if="['whyc_page'].indexOf($route.params._field)>-1"
                            style="line-height:21px;letter-spacing:2px;"
                            :result="slot"
                          ></portal-arti-detail-whycpage>
                          <portal-arti-detail-zzcp
                            v-if="['zzcp_detail','whjt_detail','zzsl_detail','zzgs_detail'].indexOf($route.params._field)>-1"
                            style="line-height:21px;letter-spacing:2px;"
                            :result="slot"
                          ></portal-arti-detail-zzcp>
                        </div>
                        <div v-else style="line-height:21px;letter-spacing:2px;" :result="slot">
                          <h3 style="text-align: center;" v-text="slot.data.artiName"></h3>
                          <content
                            v-html="slot.data.content"
                            style="line-height:21px;letter-spacing:2px;"
                          ></content>
                        </div>
                      </template>
                      <template slot="empty">
                        <div class="list-none">
                          <ul></ul>
                        </div>
                      </template>
                    </bs-detail>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <portal-footer></portal-footer>
      </div>
    </div>
  </div>
</template>
<style lange="sass" scoped>
</style>
<script>
require("../../styles/portal/culture.scss");
export default {
  data() {
    return {
      dest: false,
      title: {
        yjgl_detail: "行程攻略",
        zzln_detail: "政治理念",
        zzsl: "朱子四礼",
        zzsl_detail: "朱子四礼",
        vr: "朱子视频",
        zzlx_detail: "朱子理学",
        zzgs_detail: "朱子故事",
        jdxb_detail: "经典选编",
        jysx_detail: "教育思想",
        zzsj_detail: "政治实践",
        zzcp_detail: "朱子产品",
        whyc_detail: "文化遗存",
        whyc_page: "文化遗存",
        whyc: "文化遗存",
        whjt_detail: "文化讲坛",
        whjt: "文化讲坛",
        kw_detail: "朱子刊物"
      },
      field: {
        yjgl_detail: "yjgl",
        zzln_detail: "zzln",
        zzsl_detail: "zzsl_page",
        zzlx_detail: "zzlx",
        zzgs_detail: "zzgs",
        jdxb_detail: "jdxb",
        jysx_detail: "jysx",
        zzsj_detail: "zzsj",
        zzcp_detail: "zzcp",
        whyc_detail: "whyc",
        whyc_page: "whyc_page",
        whjt_detail: "whjt_page",
        kw_detail: "kw"
      },
      nodest: true,
      routeType: "arti",
      meta: {
        module: this.$route.params._module,
        field: this.$route.params._field
      },
      filter: {
        artiId: this.$route.params._artiId
      },
      api: null
    };
  },
  props: {
    result: {
      type: Object
    },
    routeWatch: {
      type: Boolean,
      default: true
    }
  },
  mounted() {},
  components: {
    PortalFooter: () => import("./portal-footer"),
    PortalNavTop: () => import("./portal-nav-top"),
    PortalArtiDetailWhycpage: () => import("./portal-arti-detail-whycpage"),
    PortalArtiDetailZzcp: () => import("./portal-arti-detail-zzcp"),
    PortalArtiDetailVr: () => import("./portal-arti-detail-vr"),
    PortalArtiDetailWhyc: () => import("./portal-arti-detail-whyc"),
    PortalArtiDetailDest: () => import("./portal-arti-detail-dest"),
    PortalCultNav: () => import("./portal-cult-nav"),
    PortalDestNav: () => import("./portal-dest-nav"),
    BsDetail: () => import("../../components/bs-detail")
  },
  methods: {
    handleGoBack() {},
    handleTitle(res) {
      this.$menuFn.setTitle(
        res.data.artiName +
          "-" +
          this.title[this.$route.params._field] +
          "-朱子文化·综合信息服务平台"
      );
    },
    handleArtiPage(moudle, field) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.$router.push({
        path: `/portal/arti/page/${moudle}/${field}`
      });
    }
  },
  computed: {
    currentModule() {
      return `${this.$route.params._module}_${this.$route.params._field}`;
    }
  },
  created() {
    this.$menuFn
      .setTitle
      // this.title[this.$route.params._field] + "-朱子文化·综合信息服务平台"
      ();
  },
  watch: {
    $route: function(to, from) {
      if (to.name === "portal-arti-detail") {
        this.$menuFn
          .setTitle
          // this.title[this.$route.params._field] + "-朱子文化·综合信息服务平台"
          ();
      }
      let contains = this.$loadRouteData(
        from,
        to,
        this.routeType,
        "detail",
        "portal",
        true
      );
      if (this.routeWatch && contains && this.$route.params._artiId) {
        this.$refs["refId"].clearData();
        this.meta.module = this.$route.params._module;
        this.meta.field = this.$route.params._field;
        this.filter.artiId = this.$route.params._artiId;
        this.$refs["refId"].loadData();
      }
    }
  }
};
</script>